const config = {
  // A URL base da API é definida pela variável de ambiente para produção,
  // ou aponta para localhost para desenvolvimento.
  apiBaseURL: process.env.REACT_APP_API_URL || 'http://localhost:9000',
  apiCep: 'https://viacep.com.br/ws/',
  get apiUrl() { return `${this.apiBaseURL}/api`; }, // URL completa da API derivada da base
};
 
export default config;